export default __webpack_public_path__ + "static/media/PESAGE.d32ff000.jpg";